var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141612",
    fill: "#5e708d",
    stroke: "#707070",
    d: "M0 0h17v17H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5e708d",
    "data-name": "Mask Group 1492",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47783",
    d: "M11.219 2.628H-.005v1.87h11.224Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47784",
    d: "M11.219 6.367H-.005v1.87h11.224Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47785",
    d: "M-.005 10.107h7.479v1.87H-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47786",
    d: "m8.405 11.066 1.323-1.322 1.983 1.983 3.967-3.966 1.317 1.321-5.289 5.289-3.301-3.305Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/Gray_check.de523499ef3904ecd43c62a09a728204.svg";
export { ForwardRef as ReactComponent };